import React from 'react';
import LocalizedContent from './LocalizedContent';

/** Purpose: edit a quick-reply title and optional localization mapping. Why: button text and its translation key must be configured together. */
export default function QuickReplyTitle({ option, localizationKeys, onChange, inputClass, selectClass }) {
  return <LocalizedContent localizationKey={option.localizationKey} localizationKeys={localizationKeys}
    onKeyChange={(localizationKey) => onChange({ localizationKey })} selectClass={selectClass}>
    <input
      aria-label="Manual title" className={inputClass} value={option.title || ''}
      onChange={(event) => onChange({ title: event.target.value })} placeholder="Check Policy"
    />
  </LocalizedContent>;
}
